import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../services/utils.service';

@Pipe({
    name: 'roundIfNumber',
    standalone: false
})

export class RoundIfNumberPipe implements PipeTransform {
    transform(value: any): any {

        if(value == null || value == undefined) {
            return "-";
        }

        if (!isNaN(+value)) {
            return UtilsService.FloorNumberWithDecimal(value).toLocaleString();
        } else {
            return value;
        }
    }
}